// MapMain.js
import React, {useEffect, useState} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { useReactiveVar} from '@apollo/client';
import { Button, Grow } from '@mui/material';
import NearMeIcon from '@mui/icons-material/NearMe';
import PlaceIcon from '@mui/icons-material/Place';
import HubIcon from '@mui/icons-material/Hub';
import NearMeDisabledIcon from '@mui/icons-material/NearMeDisabled'; // 추적 중지.
import MapShell, {MapMode, MapContextMenu} from '../../com/map/MapShell';
import NaverRouteSearch from '../../com/map/NaverRouteSearch';
import PopVehPosInfo from '../../com/map/PopVehPosInfo';
import PopPoiInfo from '../../com/map/PopPoiInfo';
import PopRoutePointInfo from '../../com/map/PopRoutePointInfo';
import MapDataContainer from '../../com/map/MapDataContainer';
import MapMenuAndWatch from '../../com/map/MapMenuAndWatch';
import MapShapeInput from '../../com/map/MapShapeInput';
import NaverRouteResults from '../../com/map/NaverRouteResults';
import ValueMisc from '../../value/ValueMisc';
import { useSnackbar } from 'notistack';
import { useClientSize } from '../../api/app-hook';
import {
    mapPoiAllListRepo,
    modalWorkRepo,
    naverRouteRepo, overlapRepo, rtdTermPosListRepo, userInfoRepo, vehPosFilteredRepo,
    vehPosSearchRepo
} from '../../value/AppModel';
import { AppNumber, AppStyle, AppWord, MapEvent, MapValue, TableColumnType } from '../../value/AppConst';
import { RtdTermPosDictionary } from '../rtd_term_pos/RtdTermPosDict';
import { AppConfirmDialogProvider } from '../../common/AppConfirmDialog';
import MapFloatingInfo from '../map/MapFloatingInfo';

const ViewName = 'MapMain';
const HeaderHeight = AppNumber.MapHeaderHeight;
const DataBoxWidth = 400;
const DeviderWidth = 8;
const DeviderMargin = 2;
const DeviderSpaceWidth = DeviderWidth + DeviderMargin * 2;
const MinDataBoxWidth = 300;
const MapBoxId = "id_map";
const TriangleStroke = "rgb(92, 92, 92)";
const TriangleStyle = {fill:TriangleStroke, stroke:TriangleStroke, strokeWidth:1};

const TheContainer = styled(Box)({
    fontSize:'11pt', //    display:'flex'
    position: 'relative', overflow: 'hidden', padding:0,
});
const DataBox = styled(Box)({
    display:'inline-block', position:'relative', //backgroundColor: 'cyan',left:0, top:0,
    // display:'flex', marginRight:DeviderWidth + DeviderMargin * 2, 
});
const DataInnerWrapper = styled(Box)({
    position:'absolute', left:0, top:0, right:0, bottom:0,  // backgroundColor:'yellow',
    display:'flex', // height:'100%',
});
const HeaderAndMap = styled(Box)({
    display: 'inline-block', marginLeft: DeviderSpaceWidth, marginTop:0, //position:'relative',
    // flexGrow:1, display:'flex', flexDirection:'column',
});
// const       TheHeader = styled(Box)({ height:HeaderHeight, display:'flex', alignItems:'center', backgroundColor:AppPalette.PrimaryRGB, });
const       MapBox = styled(Box)({ overflow:'hidden'});

const DeviderBox = styled(Box)({
    position: 'absolute',
    width: DeviderWidth,
    minHeight: 50,
    height: '100%',
    background: 'linear-gradient(to right, #aaaaaa, #eeeeee, #aaaaaa)',
    cursor: 'ew-resize',
    display:'flex', alignItems:'center'
});

const DividerToggleBox = styled(Box)({
    height:80,
});

const TopControlBox = styled(Box)({
    position:'absolute', height: HeaderHeight, top:0, right:0, textAlign:'right', display:'flex', alignItems:'center',
    color:'white', justifyContent:AppWord.END, paddingRight:10,
    backgroundColor:AppStyle.HeaderBackgroundColor
});

// Mouse over시 차량이나 POI 정보를 상단에 보여주고 Mouse out하면 감춘다.
const TopInfoBox = styled(Box)({
    position:'absolute', maxHeight: HeaderHeight + 4, top:1, right:1,
    backgroundColor:'#faffbb', opacity:0.70,
    boxSizing: 'border-box', padding: "1px 5px 2px 5px", overflow: "hidden",
    borderRadius: 10,
});
const TopInfoColumn = styled(Box)({display:'inline-block', paddingLeft:10, verticalAlign:'top'});
const InfoUnitRow = styled(Box)({ display: 'flex', margin:3, textAlign: 'left', alignItems:'center' });
const InfoTitleBox = styled(Box)({minWidth:50, fontSize:'0.7rem', color: '#777', display:'inline-block', padding:1, verticalAlign:'bottom', textAlign:'right'});
const InfoValueBox = styled(Box)({fontSize:'0.8rem', display:'inline-block', overflow:'hidden', padding:1, verticalAlign:'bottom'});

const AnyMenuBoxPadding = 6;
const OverlapRecordHeight = 30;
const OverlapBoxWidth = 240;
const OverlapInfoBox = styled(Box)({
    position:'absolute', backgroundColor:'white', opacity:0.8,
    width: OverlapBoxWidth,
    paddingTop: AnyMenuBoxPadding, paddingBottom: AnyMenuBoxPadding, boxSizing: 'border-box',
    fontSize: '0.9em',
    borderRadius:5, border: '1px solid #a88',overflow:'auto',
});
const OverlapRecord = styled(Box)({
    boxSizing: 'border-box', height: OverlapRecordHeight, 
    paddingLeft: AnyMenuBoxPadding, cursor: 'pointer',
    display: 'flex', alignItems:'center', //backgroundColor:'#eee'
    '&:not(:last-of-type)': {borderBottom: '1px solid #faa',},
    '&:hover':{backgroundColor:'#fdd'}
});

const ContextMenuWidth = 240;
const ContextMenuLineHeight = 30;
const ContextMenuBox = styled(Box)({
    position:'absolute', boxSizing: 'border-box', backgroundColor:'white', paddingTop: AnyMenuBoxPadding, paddingBottom: AnyMenuBoxPadding,
    width: ContextMenuWidth, fontSize: '0.9em', border: '1px solid #88f',
});

const ContextMenuLine = styled(Box)({
    boxSizing: 'border-box', height: ContextMenuLineHeight,paddingLeft: AnyMenuBoxPadding, cursor: 'pointer',
    display: 'flex', alignItems:'center',
    '&:not(:last-of-type)': {borderBottom: '1px solid #cdf',},
    '&:hover':{backgroundColor:'#eef'}
});

function filterPosBy(pos, search) {
    let textMatch = false; // true if search is not set
    if(Boolean(search)) {
        const ts = search.trim();
        if(ts.length > 0) {
            for(const col of RtdTermPosDictionary.tablePropsForMap.columns) {
                if((col.option.type===TableColumnType.TEXT || col.option.type === TableColumnType.CHAR) && pos[col.id]) {
                    if(pos[col.id].indexOf(ts) >= 0) {
                        textMatch = true;
                    }
                }
            }
        }
        else textMatch = true;
    }
    else textMatch = true;
    return textMatch;
}

const EmptyFloatingInfoProps = {
    data:null, // array of object
    dataProps:null, // array of {id, label, print}
    option:{}, // {width, rowHeight}
    top:99999,
    left:99999,
    bottom: null,
}

/**
 * Map 화면의 전체 구성. Alert 처리.
 * 최초 지점목록도 여기서 조회해서 전달. (그렇지 않으면 지점 view 선택할 때마다 새로 내려받게 됨)
 * 위치는 MapMenuAndWatch에서 반복 조회함. 그렇지 않으면 다른 view로 넘어갈 때 위치가 갱신되지 못함.
 * 점포사용자는 반드시 특정 차량을 선택하여 조회함. 데이터는 보여주지 않음.
 * 위치목록에는 동일 차량이 중복 표시될 수 있음(버그 아닌 기능). 그러나, 지도에 표시하는 마커는 하나만 출력시킴.
 */
export default function MapMain() {
	const sessionInfo = useReactiveVar(userInfoRepo);
    const [openDataBox, setOpenDataBox] = useState(true);
    const [leftWidth, setLeftWidth] = useState(DataBoxWidth);
    const [mapShell, setMapShell] = useState(null);
    // const [naverMap, setNaverMap] = useState(null);
    const [mapMenu, setMapMenu] = useState(MapMode.VehPos);
    const [contextMenuState, setContextMenuState] = useState({open:false, top: 0, left: 0, lat: 0, lon: 0, menus: null});
    const [overlapInfo, setOverlapInfo] = useState(null);
    const overlapInfoRenew = useReactiveVar(overlapRepo); // 차량, POI, 클러스터 간략한 팝업정보 보여주기 위한 데이터. {x, y, records}
    const [popVehPos, setPopVehPos] = useState({open:false});
    const [popPoi, setPopPoi] = useState({open:false});
    const [popRoutePoint, setPopRoutePoint] = useState({open:false});
    // const vehPosStat = useReactiveVar(vehPosRepo);
    const rtdTermPosData = useReactiveVar(rtdTermPosListRepo);
    const searchVehPos = useReactiveVar(vehPosSearchRepo);
    const modalWork = useReactiveVar(modalWorkRepo);
    const [naverRouteFrom, setNaverRouteFrom] = useState(null);
    const [naverRouteTo, setNaverRouteTo] = useState(null);
    const [naverRouteResult, setNaverRouteResult] = useState(null);
    const [topInfoState, setTopInfoState] = useState({open:false});
    const [mapShapeData, setMapShapeData] = useState({open:false, data:{dist:100, vertex:0}});
    const [floatingInfoProps, setFloatingInfoProps] = useState(EmptyFloatingInfoProps);
    const clientSize = useClientSize();
    const { enqueueSnackbar } = useSnackbar();
    const mapPoiAllListData = useReactiveVar(mapPoiAllListRepo);
    const naverRoutesInRepo = useReactiveVar(naverRouteRepo);


    // 초기화.
    useEffect(() => {
        const mapBox = document.getElementById(MapBoxId);
        const map = new window.naver.maps.Map(mapBox);
        // setNaverMap(map);
        const shell = new MapShell(map, sessionInfo);
        setMapShell(shell);
        // getPoiInfoList();

        // 지도에서 POI나 차량위치 마커를 클릭하면 해당 정보를 보여주는 팝업 다이얼로그를 띄우기 위한 이벤트 핸들러.
        const onBubblePopInfoBox = (event) => {
            const {detail} = event;
            if(detail.type===MapValue.MarkerType.POI) {
                setPopPoi({open:true, data: detail.data});
            }
            else if(detail.type === MapValue.MarkerType.VEH_POS) {
                setPopVehPos({open:true, data: detail.data});
            }
            else if(detail.type === MapValue.MarkerType.ROUTE_POINT) {
                setPopRoutePoint({open:true, data: detail.data});
            }
        };
        document.addEventListener(MapValue.MapEvent.PopInfoBox, onBubblePopInfoBox);

        // 이 것을 해주지 않으면 Windows에서 기존 컨텍스트 메뉴가 추가로 뜸.
        document.addEventListener("contextmenu", (event) => {
            event.preventDefault();
        });

        const onBubbleNaverRoutePoint = (event) => {
            const {detail} = event;
            if(detail.isStart) {
                setNaverRouteFrom(detail.data);
            }
            else {
                setNaverRouteTo(detail.data);
            }
        };
        document.addEventListener(MapValue.MapEvent.SetRoutePoint, onBubbleNaverRoutePoint);
        return ()=>{
            document.removeEventListener(MapValue.MapEvent.PopInfoBox, onBubblePopInfoBox);
            document.removeEventListener(MapValue.MapEvent.SetRoutePoint, onBubbleNaverRoutePoint);
        };
    },[]);

    /*
    Context menu - MapShell.js 참조
    context menu를 MapDataControl로 넣을 수 없음 - 사라지는 상태도 있기 때문에...
    */
    useEffect(()=>{
        const onMapRightClick = (event) => {
            const menus = mapShell.getContextMenuList();
            if(menus===null) return;
            if(menus.length===0) return;
            const count = menus.length + 1; // 1 for close
            const height = ContextMenuLineHeight * count + AnyMenuBoxPadding * 2;
    
            const left = event.originalEvent.pageX > window.innerWidth - ContextMenuWidth - 10 ? event.originalEvent.pageX - ContextMenuWidth : event.originalEvent.pageX;
            const top = event.originalEvent.pageY > window.innerHeight - height - 10 ? event.originalEvent.pageY - height : event.originalEvent.pageY;
            const coordLat = event.coord._lat;
            const coordLon = event.coord._lng;

            setContextMenuState({
                open: true,
                top: top, left: left,
                lat: coordLat, lon: coordLon,
                menus: menus,
            });
        };

        if(mapShell) {
            mapShell.setMapEventHandler(MapEvent.RIGHT_CLICK, MapEvent.RIGHT_CLICK+ViewName, onMapRightClick);
            mapShell.setMouseOverMarkerCallback((data) => {
                if(data) {
                    setTopInfoState({open:true, data: data});
                }
                else setTopInfoState({open:false});
            });
        }
    }, [mapShell]);

    // 사용자 설정에 따라 초기 위치 및 줌 레벨을 설정.
    useEffect(()=>{
        if(mapShell && sessionInfo.signedIn) {
            // URL Parameter로 초기 behavior 설정.
            const mapParam = ValueMisc.getUrlJsonParam();
            if(mapParam) {
                // AppMain 계열에서 인수를 주고 지도로 넘어온 경우.
                if(mapParam.job===MapValue.MapInitEvent.traceVehicle) {
                    modalWorkRepo({...mapParam});
                }
                // cut url parameter to hide it.
                ValueMisc.cutUrlParam(window.location.href);
            }
            const { viewLevel, initXcoord, initYcoord, initLat, initLon } = sessionInfo.user;
            if(initLat>=30.0 && initLon>=110.0) {
                mapShell.setCenter(initLat, initLon, viewLevel || MapValue.Level.ZOOM_INIT);
            }
            else if(initXcoord>0 && initYcoord>0) {
                const {lat,lon} = mapShell.katek2ll({x:initXcoord, y:initYcoord});
                mapShell.setCenter(lat,lon, viewLevel || MapValue.Level.ZOOM_INIT);
            }
        }
    }, [mapShell, sessionInfo.signedIn, sessionInfo.user]);

    useEffect(()=>{
        if(overlapInfoRenew) {
            setOverlapInfo(overlapInfoRenew);
        }
        else setOverlapInfo(null);
    }, [overlapInfoRenew]);

    // 검색, 핉터 등이 변화하면 필터된 위치목록 데이터를 repo테 넣고 지도에도 갱신한다.
    useEffect(()=>{
        // 목록과 지도상에 똑같은 데이터를 보여주기 위해 필터된 데이터를 repo에 저장한다. MapVehPosListRepeat.js에서 사용.
        const records = rtdTermPosData.records.filter((pos)=>filterPosBy(pos, searchVehPos));
        vehPosFilteredRepo(records);
        if(mapShell) {
            const forMarkers = [];
            const dupMap = {}; // using termId, gpsTime
            records.forEach((pos) => {
                const key = pos.termId + pos.gpsTime;
                if(!dupMap[key]) {
                    forMarkers.push({
                        vehPlates: pos.vehPlates,
                        vehAlias: pos.vehAlias,
                        lat: pos.lat,
                        lon: pos.lon,
                        vehInfoSeq: pos.vehInfoSeq,
                        speed: pos.speed,
                        distKm: pos.distKm,
                        direction: pos.direction,
                        location: pos.location,
                        posSys: pos.posSys,
                        gpsTime: pos.gpsTime,
                        operFontColor: pos.operFontColor,
                        operBackColor: pos.operBackColor,
                        noOperFontColor: pos.noOperFontColor,
                        noOperBackColor: pos.noOperBackColor,
                        offFontColor: pos.offFontColor,
                        offBackColor: pos.offBackColor,
                        reportAgeSec: pos.reportAgeSec,
                        driverName: pos.driverName,
                        driverMobile: pos.driverMobile,
                        vehTypeName: pos.vehTypeName,
                        vehTonName: pos.vehTonName,
                        comName: pos.comName,
                        tempr1: pos.tempr1 > -100 && pos.tempr1 < 100 ? pos.tempr1 : null,
                        tempr2: pos.tempr2 > -100 && pos.tempr2 < 100 ? pos.tempr2 : null,
                        tempr3: pos.tempr3 > -100 && pos.tempr3 < 100 ? pos.tempr3 : null,
                    });
                    dupMap[key] = true;
                }
            });

            mapShell.setVehPosList(forMarkers);
            //mapShell.setVehPosList([...records]); // 복제하지 않으면 mapShell내부에서 sort된 것이 테이블에도 영향을 미침.
            mapShell.showVehPosMarkers();
        }
    }, [rtdTermPosData, searchVehPos, mapShell, sessionInfo, modalWork]);

    useEffect(()=>{
        // 위 필터링과 같이하면 매번 지도표시가 갱신됨.
        if(mapShell && modalWork.vehInfoSeqToTrace>0 && rtdTermPosData.records.length>0) {
            const posToTrace = rtdTermPosData.records.filter((pos)=>modalWork.vehInfoSeqToTrace===pos.vehInfoSeq);
            if(posToTrace.length>0) {
                mapShell.morphTo(posToTrace[0].lat, posToTrace[0].lon, MapValue.Level.MAX_FOR_CLUSTER+1);
            }
            else {
                // 차량이 없으면 같은 차량번호를 가진 차량을 찾아서 적용.(modalWork.vehPlates)
                const posToTrace = rtdTermPosData.records.filter((pos)=>modalWork.vehPlates===pos.vehPlates);
                if(posToTrace.length>0) {
                    const vehInfoSeq = posToTrace[0].vehInfoSeq;
                    modalWorkRepo({...modalWork, vehInfoSeqToTrace:vehInfoSeq});
                }
            }
        }
    }, [mapShell, modalWork, rtdTermPosData]);

    useEffect(() => {
        if(!mapShell || !window.naver || !window.naver.maps) return;

        const mapWidth = openDataBox
            ? clientSize.width - leftWidth - DeviderSpaceWidth - AdditilnalMargin
            : clientSize.width - DeviderSpaceWidth - AdditilnalMargin;
        const mapHeight = clientSize.height - HeaderHeight - 2;

        if(mapWidth > 0 && mapHeight > 0) {
            mapShell.setSize(new window.naver.maps.Size(mapWidth, mapHeight));
        }
    }, [mapShell, openDataBox, leftWidth, clientSize.width, clientSize.height]);

    useEffect(()=>{
        if(mapShell) {
            mapShell.setPoiRecords(mapPoiAllListData.records);
            mapShell.showPoiMarkers();
        }
    }, [mapPoiAllListData, mapShell]);

    // <<<<<<<<<<<<<<<<<<<<<<<<<<< Devider >>>>>>>>>>>>>>>>>>>>>>>>>
    const onMouseMoveDevider = (event) => {
        if (event.buttons === 1) {
            const max = clientSize.width * 0.75;
            const w = event.clientX - DeviderMargin;
            setLeftWidth(w < MinDataBoxWidth ? MinDataBoxWidth : w > max ? max : w);
            event.stopPropagation();
        }
    };
    const onMouseUp = () => {
        document.removeEventListener(AppWord.EV_MOUSE_MOVE, onMouseMoveDevider);
        document.removeEventListener(AppWord.EV_MOUSE_UP, onMouseUp);
    };

    const onMouseDown = (event) => {
        if(openDataBox) {
            document.addEventListener(AppWord.EV_MOUSE_MOVE, onMouseMoveDevider);
            document.addEventListener(AppWord.EV_MOUSE_UP, onMouseUp);
            event.preventDefault();
            event.stopPropagation();
        }
    };

    const AdditilnalMargin = 4;
    const MapBoxWidth
        = openDataBox
        ? clientSize.width - leftWidth - DeviderSpaceWidth - AdditilnalMargin
        : clientSize.width - DeviderSpaceWidth - AdditilnalMargin;

    const toggleDataBox = () => {
        const MapWidth
            = openDataBox
            ? clientSize.width - DeviderSpaceWidth - AdditilnalMargin
            : clientSize.width - leftWidth - DeviderSpaceWidth - AdditilnalMargin;

        const size = new window.naver.maps.Size(
            MapWidth,
            clientSize.height - HeaderHeight - 2
        );
        //naverMap.setSize(size);
        if(mapShell) mapShell.setSize(size);
        /*
        
        const size = naverMap.getSize();
        size.width = openDataBox ? clientSize.width - leftWidth - DeviderSpaceWidth : clientSize.width - DeviderSpaceWidth;
        naverMap.setSize(size);
        */
        setOpenDataBox(!openDataBox);
    };

    const onClickSetMenu = (menuId) => {
        setMapMenu(menuId);
        if(mapShell) {
            mapShell.setMapMode(menuId);
        }
    };

    const onMouseOutOverlapBox = (e) => {
        //overlapRepo(null);
        if(overlapInfoRenew) setOverlapInfo(null);
    };

    const setNaverTrackStart = () => {
        setNaverRouteFrom({lat:contextMenuState.lat, lon:contextMenuState.lon, address: null});
    };

    const setNaverTrackEnd = () => {
        setNaverRouteTo({lat:contextMenuState.lat, lon:contextMenuState.lon, address: null});
    };

    const onClickContextMenu = (menuKey) => {
        setContextMenuState({open:false});

        if(menuKey===MapContextMenu.SetStartPos.key) setNaverTrackStart();
        else if(menuKey===MapContextMenu.SetEndPos.key) setNaverTrackEnd();
        else if(menuKey===MapContextMenu.DrawCircle.key) {
            const msd = {...mapShapeData};
            msd.open=true;
            msd.lat = contextMenuState.lat;
            msd.lon = contextMenuState.lon;
            setMapShapeData(msd);
        }
    };

    const onCloseMapShapeInput = (data) => {
        if(data) {
            const msd = {...mapShapeData};
            msd.open=false;
            msd.data = data;
            msd.shapeOnMap = true;
            setMapShapeData(msd);
            mapShell.drawShape(msd);
            enqueueSnackbar("도형을 클릭하거나 새 도형을 그리면 사라집니다.", {variant:'info', autoHideDuration: 2000});
        }
        else {
            const msd = {...mapShapeData};
            msd.open=false;
            setMapShapeData(msd);
        }
    };

    /**
     * naver route list: clicked on a row to show it on the map.
     * @param {NaverRoute} naverRoute 
     */
    const onClickNaverRouteRow = (naverRoute) => {
        setNaverRouteFrom(naverRoute.from);
        setNaverRouteTo(naverRoute.to);
        setNaverRouteResult(naverRoute);
    };

    /**
     * naver route list: clicked on a row to remove it.
     * @param {NaverRoute} naverRoute 
     */
    const onRequestRemoveRoute = (naverRoute) => {
        const routes = naverRoutesInRepo.filter((route)=>route.routeId!=naverRoute.routeId);
        naverRouteRepo(routes);
    }

    const onClickStopTracing = () => {
        enqueueSnackbar("추적을 중지합니다.", {variant:'info', autoHideDuration: 2000});
        modalWorkRepo({});
    };

    // 마우스가 테이블의 인덱스 셀에 들어가면 우측에 상세정보를 보여준다.
    const onMouseEnterIndexCell = (item, props, option, y) => {
        if(item && props) {
            setFloatingInfoProps({
                data: item,
                dataProps: props,
                option: option,
                top: y,
                left: leftWidth + DeviderSpaceWidth + 10,
            });
        }
        else {
            setFloatingInfoProps(EmptyFloatingInfoProps);
        }
    };

    // ############################################################
    const renderDoubleTriangleButtons = () => {
        let pointsA, pointsB; // = isOpen ? "0,20 8,16 8,24" : "0,20 8,16 8,24";
        if(openDataBox) {
            // show closing button
            pointsA = "0,20 8,16 8,24";
            pointsB = "0,40 8,36 8,44";
        }
        else {
            pointsA = "0,16 8,20 0,24";
            pointsB = "0,36 8,40 0,44";
        }

        return(
            <svg width="8" height="60">
                <polygon points={pointsA}
                    style={TriangleStyle}
                />
                <polygon points={pointsB}
                    style={TriangleStyle}
                />
          &nbsp;
        </svg>
        );
    };
    //<TheHeader>&nbsp; {/* To take space for TopControlBox */} </TheHeader>

    const renderContextMenuLine = (menu) => {
        return (
            <ContextMenuLine
                key={menu.key}
                onClick={(e)=>onClickContextMenu(menu.key)}
            >
                {menu.label}
            </ContextMenuLine>
        );
    };

    const renderContextMenu = () => {
        if(contextMenuState.open)
            return(
                <ContextMenuBox
                    style={{top: contextMenuState.top, left: contextMenuState.left}}
                >
                    {
                        contextMenuState.menus.map((menu)=>renderContextMenuLine(menu))
                    }
                    <ContextMenuLine
                        onClick={(e)=>{setContextMenuState({open:false})}}
                    >닫기</ContextMenuLine>
                </ContextMenuBox>
            );
        else return null;
    };

    const renderOverlapInfoBox = () => {
        if(overlapInfo) {
            //if(overlapInfo.y > 400) {}
            let height = overlapInfo.records.length * OverlapRecordHeight + AnyMenuBoxPadding * 2;
            if(height>400) height=400;
            const leftLimit = (openDataBox ? leftWidth : 0) + OverlapBoxWidth + 30;
            const top = overlapInfo.y > 400 ? overlapInfo.y - height + 10 : overlapInfo.y - 20;
            const left = overlapInfo.x > leftLimit ? overlapInfo.x - OverlapBoxWidth + 30 : overlapInfo.x - 40;
            return (
                <OverlapInfoBox style={{top:top, left: left, height: height+4}}
                    onMouseLeave={onMouseOutOverlapBox}
                >
                    {
                        overlapInfo.records.map((userData)=> {
                            if(userData.type===MapValue.MarkerType.POI) {
                                return (
                                    <OverlapRecord key={'poi-'+userData.data.poiKey}
                                        onClick={()=>setPopPoi({open:true, data: userData.data})}
                                        onMouseEnter={()=>setTopInfoState({open:true, data:{markerData:userData.data, type:userData.type}})}
                                        onMouseLeave={()=>setTopInfoState({open:false})}
                                    >
                                        <PlaceIcon fontSize={AppWord.SMALL} color={AppStyle.mui.success}/>
                                        {userData.data.poiName}
                                    </OverlapRecord>
                                );
                            }
                            else if(userData.type===MapValue.MarkerType.VEH_POS) {
                                return (
                                    <OverlapRecord key={'veh-'+userData.data.vehInfoSeq}
                                    onClick={()=>setPopVehPos({open:true, data: userData.data})}
                                    onMouseEnter={()=>mapShell.handleMouseOverVehPos(userData)}
                                    onMouseLeave={(e)=>mapShell.onMouseLeaveVehPos(e)}
                                >
                                        <NearMeIcon fontSize={AppWord.SMALL} color={AppStyle.mui.primary} />
                                        {userData.data.vehAlias}
                                    </OverlapRecord>
                                );
                            }
                            else if(userData.type===MapValue.MarkerType.CLUSTER) {
                                return (
                                    <OverlapRecord key={'c-'+userData.data.clusterId}
                                    onClick={(e)=>{mapShell.handleClickCluster(userData.data); onMouseOutOverlapBox(e)}}
                                    >
                                        <HubIcon fontSize={AppWord.SMALL} color={AppStyle.mui.disabled} />
                                        {userData.data.size()}개 지점
                                    </OverlapRecord>
                                );
                            }
                            else return null;
                        })
                    }
                </OverlapInfoBox>
            );
        }
        else return null;
    };

    const renderInfoUnit = (label, value) => {
        return (
            <InfoUnitRow>
                <InfoTitleBox>{label}</InfoTitleBox>
                <InfoValueBox>{value}</InfoValueBox>
            </InfoUnitRow>
        );
    };

    const renderGpsTimeAge = (pos) => {
        let txt;
        if(pos.gpsTime==='2000-01-01 00:00:00') txt = '기록없음';
        else {
            const sec = pos.reportAgeSec;
            if(sec < 180) txt = '최신보고';
            else if(sec > 86400) {
                const days = Math.floor(sec/86400);
                txt = `${days}일`;
                if(days<3) {
                    const hours = Math.floor((sec % 86400)/3600);
                    txt += ` ${hours}시간`;
                }
                txt += '전';
            }
            else {
                const hours = Math.floor(sec / 3600);
                const minutes = Math.floor((sec % 3600) / 60);
                const minTxt = `${minutes}분`;
                if(hours>0) txt = `${hours}시간 ` + minTxt;
                else txt = minTxt;
                txt += '전';
            }
        }
        return renderInfoUnit('보고경과', txt);
    };

    const renderTopVehPosBox = () => {
        const data = topInfoState.data || {};
        const pos = data.markerData || {};
        const old = data.oldest || {};

        return(
            <TopInfoBox onMouseEnter={()=>setTopInfoState({open:false})}>
                <TopInfoColumn>
                    {renderInfoUnit('차량번호',pos.vehPlates)}
                    {renderInfoUnit('차종,톤수',`${pos.vehTypeName} ${pos.vehTonName}`)}
                </TopInfoColumn>
                <TopInfoColumn>
                    {renderInfoUnit('최종보고',pos.gpsTime)}
                    {renderGpsTimeAge(pos)}
                </TopInfoColumn>
                <TopInfoColumn>
                    {
                        old.gpsTime ?
                        renderInfoUnit('경로꼬리',`${old.gpsTime.substr(5).replace('-','/')} 부터`)
                        : null
                    }
                    {renderInfoUnit('누적거리',`${ValueMisc.int2str(Math.round(pos.distKm))} Km`)}
                </TopInfoColumn>
            </TopInfoBox>
        );
    };

    const renderTopPoiBox = () => {
        const data = topInfoState.data || {};
        const poi = data.markerData || {};
        return(
            <TopInfoBox onMouseEnter={()=>setTopInfoState({open:false})}>
                <TopInfoColumn>
                    {renderInfoUnit('지점',poi.poiName)}
                    {renderInfoUnit('지점타입',poi.typeName)}
                </TopInfoColumn>
                <TopInfoColumn>
                    {renderInfoUnit('연락처',poi.officeTelno || '없음')}
                    {renderInfoUnit('주소',poi.addr || '없음')}
                </TopInfoColumn>
                {
                    poi.custPoiCode ?
                    <TopInfoColumn>
                    {renderInfoUnit('코드',poi.custPoiCode)}
                    </TopInfoColumn>
                    : null
                }
            </TopInfoBox>
        );
    };

    const renderTopInfoBox = () => {
        const data = topInfoState.data || {};
        if(data.type===MapValue.MarkerType.VEH_POS) return renderTopVehPosBox();
        else return renderTopPoiBox();
    };

    return (
        <AppConfirmDialogProvider>
            <TheContainer height={clientSize.height} onMouseLeave={onMouseOutOverlapBox}>
                {
                    openDataBox
                    ?
                    <DataBox width={leftWidth} height={clientSize.height - 2}
                        onMouseEnter={onMouseOutOverlapBox}
                    >
                        <DataInnerWrapper>
                            <MapDataContainer
                                mapShell={mapShell}
                                headerHeight={HeaderHeight}
                                mapMenu={mapMenu}
                                onChangeMapMenu={onClickSetMenu}
                                containerWidth={leftWidth}
                                onMouseEnterIndexCell={onMouseEnterIndexCell}
                            />
                        </DataInnerWrapper>
                    </DataBox>
                    :
                    null
                }
                <HeaderAndMap width={MapBoxWidth}>
                    <MapBox id={MapBoxId} height={clientSize.height - HeaderHeight - 8} style={{marginTop:HeaderHeight}}
                    >
                        Wait...
                        {/* 왜 -8을 해야하는지 당위성은 알지 못함. 하지만 현상은 패딩이 있는 것처럼 나타나기 때문에 어쩔 수 없이 적용함. */}
                    </MapBox>
                </HeaderAndMap>
                <DeviderBox onMouseDown={onMouseDown}
                    onMouseEnter={onMouseOutOverlapBox}
                    style={{left:openDataBox ? (leftWidth + DeviderMargin) : 0, top:0}}
                >
                    <DividerToggleBox
                        onClick={toggleDataBox}
                        style={{cursor:openDataBox ? "w-resize" : "e-resize"}}
                    >
                        {renderDoubleTriangleButtons()}
                    </DividerToggleBox>
                </DeviderBox>
                <TopControlBox
                    width={openDataBox ? clientSize.width-leftWidth : clientSize.width}
                    onMouseEnter={onMouseOutOverlapBox}
                >
                    {
                        modalWork.vehInfoSeqToTrace > 0
                        &&
                        <Button
                            variant={AppStyle.mui.contained}
                            color={AppStyle.mui.info}
                            style={{marginRight:10}}
                            endIcon={<NearMeDisabledIcon/>}
                            title="추적 중지"
                            onClick={onClickStopTracing}
                        >
                            {modalWork.vehPlates} 추적중
                        </Button>
                    }
                    {
                        naverRouteFrom || naverRouteTo
                        ?
                        <NaverRouteSearch
                            mapShell={mapShell}
                            posFrom={naverRouteFrom}
                            posTo={naverRouteTo}
                            resultNaverRoute={naverRouteResult}
                            onCancel={()=>{setNaverRouteFrom(null); setNaverRouteTo(null); setNaverRouteResult(null);}}
                        />
                        :
                        null
                    }
                    {
                        naverRoutesInRepo.length > 0
                        ? <NaverRouteResults
                            results={naverRoutesInRepo}
                            onRequestShowNaverRoute={onClickNaverRouteRow}
                            onRequestRemoveRoute={onRequestRemoveRoute}
                        />
                        : null
                    }
                    <MapMenuAndWatch
                        mapShell={mapShell} disabled={naverRouteFrom || naverRouteTo}
                    />
                    
                </TopControlBox>
                <Grow in={topInfoState.open}>
                    {renderTopInfoBox()}
                </Grow>
                {renderOverlapInfoBox()}
                {renderContextMenu()}
                <PopVehPosInfo
                    open={popVehPos.open}
                    vehPosData={popVehPos.data}
                    onClickClose={()=>setPopVehPos({open:false})}
                />
                <PopPoiInfo
                    open={popPoi.open}
                    poiData={popPoi.data}
                    onClickClose={()=>setPopPoi({open:false})}
                />
                <PopRoutePointInfo
                    open={popRoutePoint.open}
                    vehPosData={popRoutePoint.data}
                    onClickClose={()=>setPopRoutePoint({open:false})}
                />
                <MapShapeInput
                    open={mapShapeData.open}
                    dataDefault={mapShapeData.data}
                    onClose={onCloseMapShapeInput}
                />
            </TheContainer>
            <MapFloatingInfo
                data={floatingInfoProps.data}
                dataProps={floatingInfoProps.dataProps}
                option={floatingInfoProps.option}
                top={floatingInfoProps.top}
                left={floatingInfoProps.left}
            />
        </AppConfirmDialogProvider>
    );
}

/*




*/
